/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddressComponents
 */
export interface AddressComponents {
    /**
     * 
     * @type {string}
     * @memberof AddressComponents
     */
    longText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressComponents
     */
    shortText?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddressComponents
     */
    types?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AddressComponents
     */
    languageCode?: string | null;
}

/**
 * Check if a given object implements the AddressComponents interface.
 */
export function instanceOfAddressComponents(value: object): value is AddressComponents {
    return true;
}

export function AddressComponentsFromJSON(json: any): AddressComponents {
    return AddressComponentsFromJSONTyped(json, false);
}

export function AddressComponentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddressComponents {
    if (json == null) {
        return json;
    }
    return {
        
        'longText': json['longText'] == null ? undefined : json['longText'],
        'shortText': json['shortText'] == null ? undefined : json['shortText'],
        'types': json['types'] == null ? undefined : json['types'],
        'languageCode': json['languageCode'] == null ? undefined : json['languageCode'],
    };
}

export function AddressComponentsToJSON(json: any): AddressComponents {
    return AddressComponentsToJSONTyped(json, false);
}

export function AddressComponentsToJSONTyped(value?: AddressComponents | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'longText': value['longText'],
        'shortText': value['shortText'],
        'types': value['types'],
        'languageCode': value['languageCode'],
    };
}

